<template>
  <div class="download-wrapper">
    <div class="download-trigger hbox" @mouseenter="show = true" @mouseleave="show = false">
      <i class="iconfont icon-appxiazai"></i>
      <span>{{ $t('_app._xzbt') }}</span>
    </div>

    <!-- 下拉面板 -->
    <div class="download-panel" v-show="show" @mouseenter="show = true" @mouseleave="show = false">
      <div class="download-box">
        <div class="panel-title">{{ $t('_app._xz') }}</div>
        <div class="panel-sub">{{ $t('_app._smerm') }}</div>
        <div class="qr-grid">
          <div class="qr-item">
            <img src="../../assets/app_ios.png" alt="iOS" />
            <span>iOS</span>
          </div>
          <div class="qr-item">
            <img src="../../assets/app_android.png" alt="Android" />
            <span>Android</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadVue',
  data() {
    return {
      show: false
    }
  }
}
</script>

<style scoped>
/* ===== 容器 ===== */
.download-wrapper {
  position: relative;
  display: inline-block;
}

/* ===== 触发按钮 ===== */
.download-trigger {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 8px;
  color: #8a949f;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.25s, color 0.25s;
  user-select: none;
}

.download-trigger:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #e8edf2;
}

.download-trigger i {
  font-size: 20px;
  color: #e8edf2;
}

.download-trigger span {
  font-size: 14px;
  color: #8a949f;
}

.download-trigger:hover span {
  color: #e8edf2;
}

/* ===== 下拉面板 ===== */
.download-panel {
  position: absolute;
  top: calc(100% + 0px);
  padding-top: 12px;
  left: 50%;
  transform: translateX(-50%);
  /* 过渡动画 */
  animation: dropIn 0.2s ease;
  z-index: 100;
}

.download-box {
  min-width: 220px;
  background: #141a20;
  border-radius: 14px;
  border: 1px solid #1e262e;
  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.7);
  padding: 20px 24px 24px;
  text-align: center;
}

/* ===== 标题 ===== */
.panel-title {
  color: #e8edf2;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}

.panel-sub {
  color: #5a6672;
  font-size: 13px;
  margin-bottom: 16px;
}

/* ===== 二维码网格 ===== */
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.qr-item img {
  width: 120px;
  height: 120px;
  border-radius: 10px;
  background: #0f1419;
  padding: 4px;
  border: 1px solid #1e262e;
  display: block;
}

.qr-item span {
  color: #8a949f;
  font-size: 13px;
  font-weight: 500;
}

/* ===== 入场动画 ===== */
@keyframes dropIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-6px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .download-trigger {
    padding: 2px 6px;
  }
  .download-trigger i {
    font-size: 16px;
  }
  .download-trigger span {
    font-size: 14px;
  }
  .download-panel {
    min-width: 180px;
    padding: 16px 16px 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  .qr-item img {
    width: 80px;
    height: 80px;
  }
  .panel-title {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .download-panel {
    min-width: 160px;
    padding: 12px 12px 16px;
    right: 0;
    left: auto;
    transform: none;
  }
  .qr-item img {
    width: 65px;
    height: 65px;
  }
  .qr-grid {
    gap: 12px;
  }
  .panel-title {
    font-size: 13px;
  }
  .panel-sub {
    font-size: 11px;
  }
}

.hbox {
  height: 46px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
